(function () {
    angular.module('tradersyard').controller('ReportModalCtrl', ReportModalCtrl);

    ReportModalCtrl.$inject = ['$scope', 'graph-report-service', '$uibModal'];

    function ReportModalCtrl($scope, reportService, $uibModal) {
        const ctrl = this;

        this.$onInit = function () {
            $scope.entityInfo = this.resolve.entityInfo;

            $scope.formData = {
                reason: '',
                message: '',
            };

            $scope.errors = {};

            Object.assign($scope.formData, this.resolve.initialData || {});
        };

        this.submit = function () {
            reportService
                .create($scope.entityInfo.entryName, $scope.entityInfo.entryId, $scope.formData)
                .then(function (response) {
                    if (response.data.state === 0) {
                        ctrl.modalInstance.dismiss();
                        $uibModal.open({
                            component: 'tyReportSuccessModal',
                            backdrop: 'static',
                        });
                    } else {
                        $scope.errors = response.data.data;
                    }
                });
        };
    }
})();
